// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uppy-ProgressBar {
  /* no important */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 3px;
  transition: height 0.2s;
}

.uppy-ProgressBar[aria-hidden=true] {
  /* no important */
  height: 0;
}

.uppy-ProgressBar-inner {
  width: 0;
  height: 100%;
  /* no important */
  background-color: #1269cf;
  box-shadow: 0 0 10px rgba(18, 105, 207, 0.7);
  transition: width 0.4s ease;
}

.uppy-ProgressBar-percentage {
  position: absolute;
  top: 50%;
  left: 50%;
  /* no important */
  display: none;
  color: #fff;
  text-align: center;
  transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./node_modules/@uppy/progress-bar/dist/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gCAAgC;AAClC","sourcesContent":[".uppy-ProgressBar {\n  /* no important */\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10000;\n  width: 100%;\n  height: 3px;\n  transition: height 0.2s;\n}\n\n.uppy-ProgressBar[aria-hidden=true] {\n  /* no important */\n  height: 0;\n}\n\n.uppy-ProgressBar-inner {\n  width: 0;\n  height: 100%;\n  /* no important */\n  background-color: #1269cf;\n  box-shadow: 0 0 10px rgba(18, 105, 207, 0.7);\n  transition: width 0.4s ease;\n}\n\n.uppy-ProgressBar-percentage {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  /* no important */\n  display: none;\n  color: #fff;\n  text-align: center;\n  transform: translate(-50%, -50%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
